import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import {
  filtroDaLinha,
  filtrosDoRateio,
  serieDaCategoria,
} from "../pages/revenue/categoriaDaV2";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useCategoriaSerieV2({
  branchId,
  start,
  end,
  filtros,
  linha,
  enabled = true,
}) {
  const { getZoneAllocation, getAttentionMetrics, getEvents } = useApiV2();
  const { user } = useAuth();
  const ativo = Boolean(enabled && branchId && start && end && linha?.key);
  const base = { branch_id: branchId, start, end };
  const recorte = { ...filtrosDoRateio(filtros), ...filtroDaLinha(linha) };

  const consulta = (nome, buscar, params) => ({
    queryKey: ["categoriaSerieV2", nome, user?.user_id ?? null, params],
    queryFn: () => buscar(params),
    enabled: ativo,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });

  const [rateio, atencao, eventos] = useQueries({
    queries: [
      consulta("rateio", getZoneAllocation, {
        ...base,
        tipo: "presencial",
        group_by: "day",
        ...recorte,
      }),
      consulta("atencao", getAttentionMetrics, {
        ...base,
        group_by: "day",
        ...recorte,
      }),
      consulta("eventos", getEvents, { ...base, escopo: "zona" }),
    ],
  });

  const prontas = Boolean(rateio.data && atencao.data && eventos.data);
  const zoneIds = linha?.zone_ids;
  const data = useMemo(
    () =>
      prontas
        ? serieDaCategoria({
            start,
            end,
            rateio: rateio.data,
            atencao: atencao.data,
            eventos: eventos.data,
            zoneIds,
          })
        : null,
    [prontas, start, end, rateio.data, atencao.data, eventos.data, zoneIds]
  );

  return {
    timeseries: data?.timeseries ?? [],
    events: data?.events ?? [],
    isLoading: ativo && !prontas,
  };
}
